module.exports = __webpack_public_path__ + "img/acceso_discapacitados.08f6925f.svg";